import { registerArchetype } from './index.js';
import { applyDamage, computeDamage, lowestHpEnemy, livingEnemies, enemySide, getRuntimes, effectiveAtk, effectiveDef } from '../combat.js';
registerArchetype({
    id: 'charge_attack',
    apply: ({ state, source, params, rng }) => {
        const mult = params.multiplier ?? 1.5;
        const chargeBonus = params.chargeBonus ?? 1.0;
        const sourceRt = getRuntimes(state, source.side)[source.slot];
        const charging = sourceRt.statuses.find(s => s.kind === 'buff' && (s.params.charging ?? 0) === 1);
        if (!charging) {
            sourceRt.statuses.push({
                id: `charging_${state.tick}_${source.slot}`,
                kind: 'buff', remainingTicks: 99, params: { charging: 1 }
            });
            state.events.push({ t: state.tick, kind: 'status_apply', side: source.side, slot: source.slot, status: 'charging', duration: 99 });
            return;
        }
        sourceRt.statuses = sourceRt.statuses.filter(s => s !== charging);
        const enemies = livingEnemies(state, source.side);
        if (enemies.length === 0)
            return;
        const target = lowestHpEnemy(state, source.side);
        const dmg = computeDamage(effectiveAtk(sourceRt) * mult * (1 + chargeBonus), effectiveDef(target.runtime));
        applyDamage(state, source, { side: enemySide(source.side), slot: target.slot }, dmg, false, rng);
    }
});
